import { render } from "./SetVisibilityForm.vue?vue&type=template&id=caf10ce6&scoped=true"
import script from "./SetVisibilityForm.vue?vue&type=script&lang=js"
export * from "./SetVisibilityForm.vue?vue&type=script&lang=js"

import "./SetVisibilityForm.vue?vue&type=style&index=0&id=caf10ce6&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf10ce6"]])

export default __exports__